export const LOCALE_ID = 'en-US';
